/* eslint-disable max-len */
import React from "react";
import { useModal } from "../../../context/ModalContext";
import { CloseIcon, DoctorVisitIcon, DropOffIcon, ExpressServiceIcon, UrgentVisitIcon } from "../../../components/Icons";
import { SecondaryButton } from "../../../styles/styledComponents";
import ExpressInfoCard from "./ExpressInfoCard";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";

const ExpressVisitInfoModal = () => {
  const { closeModal } = useModal();
  const { petList }=usePetStore();


  const handleCloseModal = ()=>{
    closeModal();
  };

  const checkExpressAvailability = ()=>{
    if (petList) {
      const expressEligiblePets = petList.filter((pet) => pet.isEligibleForExpressVisit);

      return expressEligiblePets.length > 0;
    }
  };

  return (
    <div className="p-4 h-full flex flex-col justify-between">
      <div className="w-full flex justify-end">
        <CloseIcon
          onClick={handleCloseModal}
          className="text-light-black cursor-pointer"
        />
      </div>
      <div className="h-full flex flex-col gap-2 cursor-default">
        <div className="font-semibold text-xl text-center">
            All GoodVets Services
        </div>
        <div className="flex flex-col flex-1 gap-2 md:max-h-[26rem] overflow-y-auto">
          <ExpressInfoCard
            icon={<DoctorVisitIcon />}
            titleText={"Doctor Visit"}
            description={"Comprehensive care, including wellness exams, sick visits, and complex medical needs with a hospital doctor."}
            iconBackgroundColor="primary"
          />
          <ExpressInfoCard
            icon={<DropOffIcon />}
            titleText={"Drop-Off Visit"}
            description={"Conveniently drop your pet off for care, and we’ll notify you when they’re ready—pick them up when it works best for you."}
          />
          {checkExpressAvailability() &&
            <ExpressInfoCard
              icon={<ExpressServiceIcon />}
              titleText={"Express Services"}
              description={"Quick, routine technician led care for services like repeat injections, nail trims, or vaccine boosters."}
            />}
          <ExpressInfoCard
            icon={<UrgentVisitIcon />}
            titleText={"Urgent Visit"}
            description={"Quickly book an appointment at any available hospital in your area to see a Doctor immediately."}
          />
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <SecondaryButton type={"button"} className="grow !text-xs font-semibold !py-3" onClick={handleCloseModal}>
              Close
        </SecondaryButton>
        <div className="text-xs text-gray-1 text-center 2xl:px-10">
        Express Services are only available at hospitals where you have established care. If you switch locations, you may lose access to express services.
        </div>
      </div>
    </div>
  );
};

export default ExpressVisitInfoModal;
